import { React, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./PackagePage.css";

const groceryList = [
  "12.5kg Maize Meal",
  "10kg Sugar",
  "10kg Rice",
  "12.5kg Flour",
  "5L Cooking Oil",
  "1kg Tea Bags",
  "1kg Powder Milk",
  "1.5kg Coffee",
  "8kg Braai Pack",
  "10kg Potatoes",
  "10kg Onions",
  "10kg Carrots",
  "10kg Beetroot",
  "Bag of Cabbage",
  "Box of Tomatoes",
];

const packageData = {
  1: {
    name: "STANDARD PLAN",
    slogan: "Peace of Mind, Affordable Coverage",
    joiningFee: "R280.00",
    monthlySub:"R220.00",
    members: ["Main Member", "10 Dependents", "6 Months Probation Period"],
    includes: [
      "Coffin",
      "Coffin Spray",
      "Hearse",
      "Family Cars x2",
      "Bus",
      "Set Of Screens At Home",
      "Grave Booking",
      "Water",
      "Tent At Home",
      "3 Tables",
      "100 Chairs",
      "Airtime",
      "Grocery",
    ],
    groceries: groceryList,
  },
  2: {
    name: "CASKET PLAN",
    slogan: "Full Coverage for Your Loved Ones",
    joiningFee: "R880.00",
    monthlySub:"R350.00",
    members: ["Main Member", "6 Dependents", "6 Months Probation Period"],
    includes: [
      "Coffin",
      "Coffin Spray",
      "Hearse",
      "Family Cars x2",
      "Bus",
      "Set Of Screens At Home",
      "Grave Booking",
      "Water",
      "Tent At Home",
      "3 Tables",
      "100 Chairs",
      "Airtime",
      "Grocery",
    ],
    groceries: groceryList,
  },
  3: {
    name: "MINI DOME PLAN",
    slogan: "VIP Funeral Experience",
    joiningFee: "R1,200.00",
    monthlySub:"R600.00",
    members: ["Main Member", "6 Dependents", "6 Months Probation Period"],
    includes: [
      "Coffin",
      "Coffin Spray",
      "Hearse",
      "Family Cars x2",
      "Bus",
      "Set Of Screens At Home",
      "Grave Booking",
      "Water",
      "Tent At Home",
      "3 Tables",
      "100 Chairs",
      "Airtime",
      "Grocery",
    ],
    groceries: groceryList,
  },
};

export default function PackagePage() {
  const { id } = useParams();
  const pkg = packageData[id];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!pkg) return <h2 style={{ textAlign: "center" }}>Package not found</h2>;

  return (
    <div className="package-page">
      {/* HERO */}
      <section className="package-hero">
        <div className="hero-text">
          <h1>{pkg.name}</h1>
          <p className="hero-slogan">{pkg.slogan}</p>
          <p className="joining-fee">Joining Fee</p>
          <p className="hero-fee">{pkg.joiningFee}</p>
          <p className="monthly-prem">{pkg.monthlySub} per month</p>
        </div>
      </section>

      {/* CONTENT */}
      <div className="package-content">
        <div className="package-main">
          {/* MEMBERS */}
          <section className="package-section">
            <h2>Members Covered</h2>
            <ul>
              {pkg.members.map((member, index) => (
                <li key={index}>{member}</li>
              ))}
            </ul>
          </section>

          {/* INCLUDES */}
          <section className="package-section">
            <h2>Package Includes</h2>
            <ul>
              {pkg.includes.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>
        </div>

        {/* GROCERY CARD */}
        <aside className="grocery-card">
          <h3>Grocery List</h3>
          <ul>
            {pkg.groceries.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </aside>
      </div>
    </div>
  );
}
